// extracted by mini-css-extract-plugin
export var card = "_mi-0";
export var content = "_mi-2";
export var details = "_mi-3";
export var icon = "_mi-1";
export var iconBlue = "_mi-5";
export var iconBrand = "_mi-4";
export var iconGrayBlue = "_mi-6";
export var iconGreen = "_mi-7";
export var iconIndigo = "_mi-8";
export var iconOrange = "_mi-9";
export var iconPurple = "_mi-a";
export var iconRed = "_mi-b";
export var iconWarning = "_mi-c";